<template>
  <div class="page-wrapper">
    <div class="stepper-header">
      <v-img alt="Step Logo" class="step3-image step-logo"/>
      <span class="reg-titre1" v-html="title"></span>
    </div>

    <div>
      <v-form ref="USER" lazy-validation>
        <div class="edit-field-label">{{ label }}</div>

        <v-select
            v-model="selectedOption"
            :items="options"
            variant="outlined"
            density="compact"
            max-width="261px"
            class="custom-combobox"
            min-width="50px"
            :menu-props="{ contentClass: 'custom-dropdown' }"
        />
      </v-form>
    </div>
  </div>

  <div class="action-footer">
    <loader-button
        :label="precedentBtnTxt"
        :outlined="true"
        @callback="previous"
    />
    <loader-button
        :label="suivantBtnTxt"
        @callback="next"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import {AppButtons, AppCustoms, RessourceAppButton, RessourceAppCustom} from "@/ressources/globalRessources.ts";
import LoaderButton from "@/framework/base/components/LoaderButton.vue";
import SiretInscription from "@/generated/classes/SiretInscription.ts";

export default defineComponent({
  components: {
    LoaderButton
  },
  props: {
    subscription: {
      type: Object as PropType<SiretInscription>,
      required: true
    },
  },
  data() {
    return {
      selectedOption: 'Production',
      options: ['Production', 'Tournée', 'Autres'],
      label:'Activité'
    }
  },
  computed: {
    title(): string {
      return RessourceAppCustom(AppCustoms.REGISTER_ETAPE3_LABEL).label;
    },
    suivantBtnTxt(): string {
      return RessourceAppButton(AppButtons.SUIVANT).label;
    },
    precedentBtnTxt(): string {
      return RessourceAppButton(AppButtons.PRECEDENT).label;
    },
  },
  methods: {
    previous() {
      this.subscription.verifyNumero = false;
      this.$emit('previous');
    },
    next() {
      this.$emit('next');
    }
  }
})
</script>

<style>

.v-select.custom-combobox .v-field {
  background-color: rgb(var(--v-theme-grey97)) !important;
  border-radius: 8px !important;
}

.custom-dropdown .v-list-item-title {
  color: rgb(var(--v-theme-secondary40)) !important; /* Dark text */
  font-size: 12px !important;    /* Adjust font size */
  font-weight: 500;
}

.custom-fieldS3 .v-field input {
  background-color: rgb(var(--v-theme-grey97)) !important;
  border-radius: 8px !important;
  text-align: center;
}

.custom-fieldS3 .v-field input::placeholder {
  letter-spacing: 2px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}

</style>